import { render } from "./ActionTextButtons.vue?vue&type=template&id=e148e13e&scoped=true"
import script from "./ActionTextButtons.vue?vue&type=script&lang=js"
export * from "./ActionTextButtons.vue?vue&type=script&lang=js"

import "./ActionTextButtons.vue?vue&type=style&index=0&id=e148e13e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e148e13e"]])

export default __exports__